import { list } from 'redom';

import SingleSelectOption from './option';

class SingleSelectOptions {

  constructor(singleSelectOptionWrapperClass, singleSelectOptionClass, LabelView, onOptionSelect) {

    this.el = list(`ul.single-select-options-list.hide-scrollbar.${singleSelectOptionWrapperClass}`, SingleSelectOption, null, {
      singleSelectOptionClass,
      LabelView,
      onOptionSelect
    });

  }

  update(options, singleSelect) {

    this.el.update(options, singleSelect);

  }

}

export default SingleSelectOptions;